import ENVIRONMENTS from 'constants/enviroments';

class AttendanceWebsocket {
  websocket: any;

  connect() {
    this.websocket = new WebSocket(ENVIRONMENTS.ATTENDANCE.WEBSOCKET_URL!);
  }

  send(data: any) {
    this.websocket.send(data);
  }
}

let socket = new AttendanceWebsocket();

export default socket;
